const STAGING_BRANCH = 'master';

const VERCEL_ENV = process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV;
const VERCEL_GIT_COMMIT_REF = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF || process.env.VERCEL_GIT_COMMIT_REF;

export const isPreview = (): boolean => {
  return VERCEL_ENV === 'preview' && VERCEL_GIT_COMMIT_REF !== STAGING_BRANCH;
};

export const isProduction = (): boolean => {
  return VERCEL_ENV === 'production';
};

export const isStaging = (): boolean => {
  return VERCEL_ENV === 'preview' && VERCEL_GIT_COMMIT_REF === STAGING_BRANCH;
};

export const getEnv = (): string => {
  if (isPreview()) return 'preview';
  if (isProduction()) return 'production';
  if (isStaging()) return 'staging';
  return 'development';
};

export const isDevelopment = (): boolean => {
  return getEnv() === 'development';
};

export const getRelease = (): string => {
  return (
    process.env.VERCEL_GIT_COMMIT_SHA ||
    process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ||
    `local-development-${new Date().getTime()}`
  );
};

export const getIsSentryEnabled = () => (isStaging() || isProduction()) && !process.env.NEXT_DISABLE_SENTRY;

export const NEXT_PUBLIC_SIGNUPS_BACKEND_URL =
  process.env.NEXT_PUBLIC_SIGNUPS_BACKEND_URL ||
  (isProduction() ? 'https://signups-backend.motimate.app' : 'https://signups.motimateapp-staging.com');
